import { render, staticRenderFns } from "./OrganismEditServiceData.vue?vue&type=template&id=6edf0576&scoped=true&"
import script from "./OrganismEditServiceData.vue?vue&type=script&lang=js&"
export * from "./OrganismEditServiceData.vue?vue&type=script&lang=js&"
import style0 from "./OrganismEditServiceData.vue?vue&type=style&index=0&id=6edf0576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edf0576",
  null
  
)

export default component.exports